<ng-container *ngIf="loading; else viewTemplate">
  <div style="min-height:50vh;" fxLayout="row" fxLayoutAlign="center center">
      <uni-loader></uni-loader>
  </div>
</ng-container>
<ng-template #viewTemplate>
  <app-journal-header
    [blog]="blog"
    [wordCount]="textCount"
    [imageCount]="imageCount"
    [embedCount]="embedCount"
    [canPublish]="canPublish"
    [next]="false"
    style="width:100%">
  </app-journal-header>
  <div class="blog-meta-wrapper">
    <div class="blog-container" fxLayout="column">
      <uni-thumbnail-uploader
        [uuid]="blog.uuid"
        [title]="blog.title"
        [subtitle]="blog.tagline"
        [image]="blog.image"
        [type]="'Blog'"
        (media)="media($event)"
        view="landscape">
      </uni-thumbnail-uploader>
  
      <div class="blog-type-discipline-section" >
        <div class="width-100" fxLayout="row" fxLayout.lt-md="column" fxLayoutGap="16px">
          <div fxLayout="row" class="width-100" style="width: 600px;">
            <p class="text" style="margin:auto 10px auto 0;">This is a</p>
          <mat-form-field class="dropdown-menu" style="margin: auto 10px auto 0;">
            <mat-select [(ngModel)]="defaultBlogType" [formControl]="blogTypeControl" required>
              <mat-option class="text" *ngFor="let type of blogTypeArray" [value]="type.id" (click)="changeBlogType(type)">
                {{ type.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <p class="text" style="margin:auto 10px auto 0;">published under</p>
          </div>
          <mat-form-field class="disciplines">
            <mat-chip-list #disciplinesList>
              <mat-chip class="text" *ngFor="let discipline of blog.disciplines"
              [selectable]="true"
              [removable]="true">
              <ng-container *ngIf="discipline.icon">
                <uni-image
                  [src]="discipline.icon"
                  [default]="defaultImage"
                  [alt]="discipline.name ? discipline.name : 'discipline image'"
                  [height]="24"
                  [width]="24"
                  auxClassList="chip-img">
                </uni-image>
              </ng-container>
              <i class="chip-img icon-discipline" *ngIf="!discipline.icon"></i>
              <span class="chip-text">
                {{ discipline.name }}
              </span>
              <i class="icon icon-cross-bold" (click)="removeDiscipline(discipline)"></i>
              </mat-chip>
              <input
              placeholder="Disciplines (Maximum 2)"
              [disabled]="hasAllDisciplines"
              [formControl]="disciplinesControl"
              [matAutocomplete]="autocomplete"
              #disciplineInput
              [matChipInputFor]="disciplinesList"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              >
            </mat-chip-list>
            <mat-autocomplete #autocomplete="matAutocomplete" (optionSelected)="addDiscipline($event)">
              <ng-container *ngIf="filteredDisciplines && filteredDisciplines.length > 0; else elseTemplate">
                <mat-option
                  *ngFor="let discipline of filteredDisciplines"
                  [value]="discipline"
                  >
                  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
                    <uni-image [src]="discipline?.icon" [width]="32" [height]="32" classes="fit-cover border-radius-5">
                    </uni-image>
                    <p class="margin-0">{{ discipline.name }}</p>
                  </div>
                </mat-option>
              </ng-container>
              <ng-template #elseTemplate>
                <mat-option>
                  No result found
                </mat-option>
              </ng-template>
  
          </mat-autocomplete>
          </mat-form-field>
        </div>
  
        <span class="font-xs font-light danger" *ngIf="blog.disciplines.length == 0"> Please select at least one discipline</span>
      </div>
      <div class="tags-section" fxLayout="row">
        <form class="width-100" (ngSubmit)="createTag(tagSearchControl.value)">
          <mat-form-field class="width-100">
            <mat-chip-list #tagList>
              <mat-chip
                class="text"
                *ngFor="let tag of blog.tags"
                [selectable]="selectable"
                [removable]="removable">
                <ng-container *ngIf="tag.icon">
                  <uni-image
                    [src]="tag.icon"
                    [default]="defaultImage"
                    [alt]="tag.name? tag.name : tag.type? tag.type : 'tag image'"
                    [height]="24"
                    [width]="24"
                    auxClassList="chip-img">
                  </uni-image>
                </ng-container>
                <i class="chip-img icon-tag" *ngIf="!tag.icon"></i>
                <span class="chip-text">
                  {{ tag.name }}
                </span>
                <i class="icon icon-cross-bold" (click)="removeTag(tag)"></i>
              </mat-chip>
              <input
                placeholder="Tags (Maximum 5)"
                [disabled] = "hasAllTags"
                #tagInput
                [formControl]="tagSearchControl"
                [matAutocomplete]="auto"
                [matChipInputFor]="tagList"
                [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                (matChipInputTokenEnd)="createTag($event)">
            </mat-chip-list>
            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addTag($event)">
              <mat-option *ngFor="let tag of filteredTagsArray" [value]="tag">
                {{ tag.name }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </form>
      </div>
      <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="16px" class="cursor-pointer">
        <uni-navigation-button
          default="Back"
          (click)="goBack()"
          button_class="primary">
        </uni-navigation-button>
        <uni-navigation-button
          default="Publish"
          (click)="publishBlog()"
          [disabled]="!canPublish"
          button_class="primary">
        </uni-navigation-button>
      </div>
    </div>
  </div>
</ng-template>
